import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

const useHeadTrackSelector = () => {
  const addToQuote = useStore((state) => state.addToQuote);

  const material = useStore((state) => state.quote.material);
  const doorType = useStore((state) => state.quote.doorType);

  const headTrackColor = useStore((state) => state.quote.headTrackColor);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const isAlumBifold =
    material === "All Aluminum" && doorType?.includes("Bi-fold");

  const handleClick = (label: string) => {
    const checked = checkMark(label);

    addToQuote({ headTrackColor: !checked ? label : "" }, "headTrackColor");

    if (!checked && findRequired("Head Track Color"))
      removeRequired("Head Track Color");
  };

  const variant = (label: string) =>
    label === headTrackColor ||
    label.replace("Anodized", "").trim() === headTrackColor
      ? "filled"
      : "outlined";

  const checkMark = (label: string) =>
    label === headTrackColor ||
    label.replace("Anodized", "").trim() === headTrackColor;

  return {
    handleClick,
    variant,
    checkMark,
    isAlumBifold
  };
};

export default useHeadTrackSelector;
